import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'
import styles from "./style.module.css"
import { AiFillEye } from 'react-icons/ai'


const ReasonModel = ({ el, type }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <p onClick={onOpen} className={styles.reasonButton}>Reason</p>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
          </ModalBody>
          <div className={styles.deleteModeldiv}>
            <p>Reason</p>
          </div>
        </ModalContent>
      </Modal>
    </>

  )
}

export default ReasonModel